import { formatAmount, formatDate } from 'helpers';
import fp from 'lodash/fp';

export const getPercentage = fp.compose(formatAmount, fp.get('percentage'));

export const getCreated = fp.compose(formatDate, fp.get('created'));
